'use client';

import React from 'react';
import SparePartsCarousel from '@/components/organisms/spare-parts-carousel';
import { DataSource } from '@/types/lib/datasources';
import { Product } from '@shared/types/product';
import type { CtProductsBySku } from '@/utils/server/getCtSnapshotForSku';

interface SparePartsSliderProps {
  data: DataSource<{ items: Product[] }>;
  /** EWM-433 / EWM-525 — Standalone price + stock per spare-part SKU, resolved + cached server-side. */
  ctBySku: CtProductsBySku;
}

// EWM-433 — PDP "Spare Parts" section. Thin wrapper: unwrap the data source and
// hand the products + price/stock snapshots to the shared SparePartsCarousel.
const RelatedProductsSliderClientWrapper = ({ data, ctBySku }: SparePartsSliderProps) => {
  const items = data?.data?.dataSource?.items ?? [];
  return <SparePartsCarousel items={items} ctBySku={ctBySku} />;
};

export default RelatedProductsSliderClientWrapper;
